import styled, {css} from "styled-components/macro";
import {Background, IsDisabled} from "../../../../data";
import IconSelectedMark from "../../../Icons/IconSelectedMark";

export const Root = styled.div<Partial<IsDisabled>>`
    width: 100%;
    position: relative;
    cursor: pointer;
    border: 1.5px solid var(--color-border);
    border-radius: 50%;
    transition: border 0.3s;
    
    ${(props) => props.$isDisabled && css`
        opacity: 0.3;
    `}
    
    &:hover {
        border-color: var(--color-border-hover);
    }
`;

export const Image = styled.div<Partial<Background>>`
    width: 100%;
    padding-top: 100%;
    overflow: hidden;
    border-radius: 50%;
    background-color: #e2e2e2;
    background-size: cover;
    
    ${(props) => props.$background && css`
        background-image: url(${props.$background});
    `}
`;

export const IconLetter = styled.div`
    width: 16px;
    height: 16px;
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    color: var(--color-accent-reversed);
    background-color: var(--color-accent);
    border-radius: 50%;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
`;

export const IconSelectedWrap = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;

export const IconSelected = styled(IconSelectedMark)`
    padding-top: 3px;
    padding-left: 1px;
        width: 20px;
        height: 25px;
`;
